// Libraries
import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const defaultProps = {
  width: '50.273px',
}

// Component
function IconEmpty({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="37.705"
      viewBox="0 0 50.273 37.705"
    >
      <g transform="translate(0 -127.988)">
        <g transform="translate(0 127.988)">
          <g transform="translate(0 0)">
            <path
              fill="#abc4db"
              d="M50.259,146.769a2.074,2.074,0,0,0-.119-.664l-6.284-16.758a2.094,2.094,0,0,0-1.961-1.359H35.61a2.095,2.095,0,1,0,0,4.189h4.83l4.713,12.568H35.61a2.094,2.094,0,0,0-2.095,2.095v4.189H16.758V146.84a2.094,2.094,0,0,0-2.095-2.095H5.117L9.83,132.177h4.833a2.095,2.095,0,1,0,0-4.189H8.379a2.1,2.1,0,0,0-1.963,1.359L.132,146.105a2.071,2.071,0,0,0-.117.664c0,.025-.015.046-.015.071V163.6a2.094,2.094,0,0,0,2.095,2.095H48.179a2.094,2.094,0,0,0,2.095-2.095V146.841C50.273,146.815,50.259,146.794,50.259,146.769Z"
              transform="translate(0 -127.988)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

IconEmpty.propTypes = propTypes

IconEmpty.defaultProps = defaultProps

export default IconEmpty
